import React from 'react';
import Tooltip from '@/components/Tooltip';
import OpenAILogo from '@/components/icons/OpenAILogo';

// KeyStatTooltipContent helper component for tooltips
const KeyStatTooltipContent: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="w-64 p-2 text-xs font-mono">
    {children}
  </div>
);

// StatCard component to standardize the stat block appearance
const StatCard: React.FC<{
  title: string;
  value: string;
  footer: string;
  tooltipContent: React.ReactNode;
  isOpenBrain?: boolean;
}> = ({ title, value, footer, tooltipContent, isOpenBrain = false }) => (
  <Tooltip content={<KeyStatTooltipContent>{tooltipContent}</KeyStatTooltipContent>}>
    <div className={`px-4 py-2 rounded-md h-full ${isOpenBrain ? "bg-[var(--accent)] text-white" : "border border-black"} relative`}>
      {isOpenBrain && (
        <div className="absolute top-2 right-2">
          <OpenAILogo size={20} color="white" />
        </div>
      )}
      <div className={`text-[10px] uppercase mb-1 ${isOpenBrain ? "text-white" : "text-gray-500"}`}>{title}</div>
      <div className="text-2xl font-bold">{value}</div>
      <div className={`text-[10px] ${isOpenBrain ? "text-white" : "text-gray-500"}`}>{footer}</div>
    </div>
  </Tooltip>
);

const KeyMetrics2026: React.FC = () => {
  return (
    <div className="font-mono mt-8 mb-8">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
        
        {/* Global AI Title + First Stat */}
        <div className="order-10 lg:order-none">
          <StatCard 
            title="CAPEX GLOBAL EN IA"
            value="$1 B"
            footer="COSTO DE PROPIEDAD DEL PODER DE CÓMPUTO ACTIVO"
            tooltipContent={"Gasto global total en infraestructura de IA."}
          />
        </div>

        {/* Title - spans 2 columns */}
        <div className="col-span-2">
          <h2 className="text-[40px] font text-right not-italic mt-0 mb-0 font-bold font-sans tracking-tight uppercase">MÉTRICAS CLAVE DEL 2026</h2>
          {/* <h3 className="text-xl font-bold mb-4 uppercase italic bg-[var(--accent)] text-white inline-block px-2 py-1">OPENMIND</h3> */}
        </div>

        {/* Global AI stats - row 2 */}
        <div className="order-11 lg:order-none">
          <StatCard 
            title="POTENCIA GLOBAL DE LA IA"
            value="38 GW"
            footer="POTENCIA PICO"
            tooltipContent={"Pico de consumo global de los sistemas de IA."}
          />
        </div>
        
        {/* OpenBrain stats - row 1, columns 1-2 */}
        <div className="order-1 lg:order-none">
          <StatCard 
            title="INGRESOS DE OPENBRAIN"
            value="$35 000 M"
            footer="ANUAL 2026"
            tooltipContent={"Ingresos anuales estimados de OpenBrain para 2026."}
            isOpenBrain={true}
          />
        </div>
        
        <div className="order-2 lg:order-none">
          <StatCard 
            title="GASTO DE CAPITAL"
            value="$200 000 M"
            footer="COSTO DE PROPIEDAD DE LA INFRAESTRUCTURA INFORMÁTICA DE OPENBRAIN"
            tooltipContent={"Gasto total de capital para la infraestructura informática de OpenBrain."}
            isOpenBrain={true}
          />
        </div>

        {/* Global AI stats - row 3 */}
        <div className="order-12 lg:order-none">
          <StatCard 
            title="PORCENTAJE DE LA POTENCIA DE EE. UU. PARA LA IA"
            value="2,5 %"
            footer="33 GW DE CAPACIDAD DE 1,34 TW"
            tooltipContent={"Porcentaje de la capacidad eléctrica de EE. UU. utilizada para operaciones de IA."}
          />
        </div>
        
        
        
        {/* OpenBrain stats - row 2, columns 1-2 */}
        <div className="order-3 lg:order-none">
          <StatCard 
            title="COSTO DEL CÓMPUTO DE OPENBRAIN"
            value="$40 000 M"
            footer="ANUAL 2026"
            tooltipContent={"Costo anual del poder de cómputo para las operaciones de OpenBrain."}
            isOpenBrain={true}
          />
        </div>
        
        <div className="order-4 lg:order-none">
          <StatCard 
            title="NECESIDADES ENERGÉTICAS DE OPENBRAIN"
            value="6 GW"
            footer="POTENCIA PICO"
            tooltipContent={"Pico de las nececidades energéticas de la infraestructura informática de OpenBrain."}
            isOpenBrain={true}
          />
        </div>
        
        
        
        
      </div>
    </div>
  );
};

export default KeyMetrics2026;
